import Bookmarks from '../bookmarks'

class BookmarkedTraining extends Bookmarks {
    
    /**
     * Construct component
    */
    constructor() {
        super(typeof bookmarkedTrainings == 'undefined' ? [] : bookmarkedTrainings)
    }
    
}

export default (new BookmarkedTraining())